import React from 'react';
import './PrivacyPolicy.css'; // Create this CSS file for styling

const PrivacyPolicy = () => {
  
    return (
    <div className='privacy-policy-background-color'>
    <div className="privacy-policy-container">
      <div className="reset-password-logo">
        <img src=" https://firebasestorage.googleapis.com/v0/b/tabitapp-6b25a.appspot.com/o/TABITA-LOGO%20small.png?alt=media&token=152bfee7-fc9e-48de-b957-efcca798f0ed" alt="Logo" />
      </div>
      <h2>Privacy Policy<br/><br/>Tabita</h2>
    <p>
        <strong>Effective Date:</strong> June 8th 2024<br/>
        <strong>Last Updated:</strong> June 8th 2024<br/>
    </p>
    <p>
        <strong>Introduction</strong><br/>
        Welcome to Tabita, a dedicated platform for the Catholic women's group "Tabita." We are committed to protecting your privacy and ensuring you have a positive experience on our website and in all interactions with our services. This Privacy Policy applies to all personal information collected during your interactions with us.<br/><br/>
        
        <strong>Information We Collect</strong><br/>
        <strong>Personal Information:</strong> We collect information that personally identifies you, such as your name, email address, and phone number when you register with us.<br/>
        <strong>Group Communications:</strong> As part of group activities, we collect information related to your participation in group messages and events.<br/>
        <strong>Usage and Device Information:</strong> We may automatically collect information about how you access and use the site, as well as information about the device you use to access the site.<br/><br/>
        
        <strong>How We Use Your Information</strong><br/>
        <strong>To Provide Services:</strong> We use your information to manage your account, provide customer support, and ensure seamless communication within your group.<br/>
        <strong>To Improve Our Services:</strong> We analyze usage information to understand how our services are used and to improve the functionality and quality of our services.<br/>
        <strong>To Communicate:</strong> We may use your information to communicate important notices, such as changes to our terms, conditions, and policies.<br/><br/>
        
        <strong>Sharing of Your Information</strong><br/>
        We do not share your personal information with third parties, except as required to provide services you have requested, or under the following circumstances:<br/>
        <strong>Service providers:</strong> We may share your information with service providers who perform services on our behalf.<br/>
        <strong>Legal requirements:</strong> We may disclose your information if required by law or if we believe in good faith that such action is necessary to comply with a legal obligation.<br/><br/>
        
        <strong>Your Rights</strong><br/>
        You have the right to access, correct, or delete your personal information. You can also object to or restrict the processing of your information. To exercise these rights, please contact us at lucas4.18usa@gmail.com.<br/><br/>
        
        <strong>Changes to This Privacy Policy</strong><br/>
        We may update this privacy policy from time to time. The most current version of the policy will govern our processing of your personal data and will always be available on our website.<br/><br/>
        
        <strong>Contact Us</strong><br/>
        If you have any questions or concerns about our privacy practices, please contact us at lucas4.18usa@gmail.com.
    </p>
      
    </div>
    </div>
    )
};

export default PrivacyPolicy;